exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-profile .card[data-v-23a37cce]{min-height:190px}", ""]);

// exports
